<app-loading-spinner
  *ngIf="!article$"
  [message]="'action.loading' | translate"
></app-loading-spinner>

<article *ngIf="article$ | async as article" class="article-container">
  <!-- header container-->
  <div class="article-header">
    <div class="article-header-content">
      <!--check the locale the display the locale in good formats-->
      <p class="article-header-content-publishedAt" translate fxHide.xs>
        <span translate>article.publish </span
        >{{ article.attributes.publishedAt | articleDate: locale }}
      </p>

      <h3 class="article-header-content-title">
        {{ article.attributes.title }}
      </h3>
      <p
        class="article-header-content-publishedAt"
        translate
        fxHide.sm
        fxHide.md
        fxHide.lg
        fxHide.xl
      >
        <span translate>article.publish </span
        >{{ article.attributes.publishedAt | articleDate: locale }}
      </p>

      <p class="article-header-content-resume">
        {{ article?.attributes?.description }}
      </p>
    </div>
    <figure>
      <img
        [media]="article.attributes.image.data"
        [format]="'large'"
        class="article-header-image"
      />
    </figure>
  </div>
  <!-- rich text container -->
  <div class="article-content">
    <hr class="article-divider" />
    <div
      class="article-content-richtext"
      *ngIf="article.attributes.text"
      [innerHTML]="article.attributes.text | safeHtml"
    ></div>
    <hr class="article-divider" />
    <div class="separator"></div>
  </div>
</article>
